import { useQuery } from 'react-query';
import { QUERY_KEYS_PUBLIC } from 'api/query-keys';
import { getWorkerByWorkerId } from 'shared/services/worker-service';
import {
  FlexWorkerLevelFilters,
  GetWorkerByWorkerIdResponse,
} from 'shared/services/worker-service.types';
import { UseWorkerByIdParams } from './types';

export const useGetWorkerByWorkerId = ({
  workerId,
  verified,
  level = FlexWorkerLevelFilters.COMPLETE,
}: UseWorkerByIdParams) => {
  return useQuery<GetWorkerByWorkerIdResponse, Error>(
    QUERY_KEYS_PUBLIC.workerById(workerId, level, verified),
    () => getWorkerByWorkerId({ workerId, verified, level }),
    {
      enabled: !!workerId,
    }
  );
};
